import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { ProductService } from '../product/product.service';
import { ServicesService } from '../services/services.service';
import { OrderData } from './models/order-data';

@Component({
  selector: "app-order",
  templateUrl: "./order.component.html",
  styleUrls: ["./order.component.css"],
})
export class OrderComponent {
  isViewOrderInfo: any = false;

  orderData: OrderData = new OrderData;

  constructor(private route: ActivatedRoute) {
    this.route.queryParams.subscribe((params) => {
      this.orderData.clientId = params["cid"];
      this.orderData.clientName = params["cname"];
    });
  }

  public onViewOrder(orderData: OrderData): void {
    this.orderData = orderData;
    this.isViewOrderInfo = true;
  }

  public onViewOrders(orderData: OrderData): void {
    this.isViewOrderInfo = false;
  }
}
